module.exports = __webpack_public_path__ + "img/stadia-home-launch.076d36d2.jpg";